import { render, staticRenderFns } from "./OrganizationForm.vue?vue&type=template&id=45765ec6&scoped=true&"
import script from "./OrganizationForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationForm.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationForm.vue?vue&type=style&index=0&id=45765ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45765ec6",
  null
  
)

export default component.exports